<template>
  <span v-if="isValid && !loading" class="amount" v-text="formattedAmount"/>
  <span v-else style="user-select: none">&nldr;</span>
</template>

<script>
// Intl.NumberFormat construction is relatively expensive, and this component is
// rendered many times per table (multiple money cells per row). Cache formatter
// instances by decimal-places so every row/render reuses the same formatter
// instead of constructing a new one each time.
const formatterCache = new Map();

const getFormatter = (decimalPlaces) => {
  if (!formatterCache.has(decimalPlaces)) {
    formatterCache.set(decimalPlaces, new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }));
  }

  return formatterCache.get(decimalPlaces);
};

export default {
  name: 'Money',
  props: {
    amount: {
      type: [Number, String],
    },
    decimalPlaces: {
      type: Number,
      default: 2,
    },
    loading: Boolean,
  },
  computed: {
    isValid() {
      let value = this.amount;

      if (!isNaN(value) && value !== null && value !== '') {
        value = Number(value);
      }

      return typeof value === 'number' && isFinite(value) && !isNaN(value);
    },
    formattedAmount() {
      if(!this.isValid) {
        return null;
      }

      return getFormatter(this.decimalPlaces ?? 2).format(this.amount);
    }
  }
};
</script>

<style scoped lang="scss">
.amount {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-style: normal;
  font-weight: 480;
  font-variation-settings: "wght" 480, "opsz" 12;
  letter-spacing: -0.018em;
  text-decoration: none;
  text-transform: none;
  font-feature-settings: "case" 0, "dlig" 0, "frac" 0, "dnom" 0, "numr" 0, "subs" 0, "sups" 0, "tnum", "zero" 0, "ss01" 0, "ss02" 0, "ss03" 0, "ss04" 0, "ss05" 0, "ss06" 0, "ss07" 0, "ss08" 0, "cv01" 0, "cv02" 0, "cv03" 0, "cv04" 0, "cv05" 0, "cv06" 0, "cv07" 0, "cv08" 0, "cv09" 0, "cv10" 0, "cv11" 0, "cv12" 0, "cv13" 0, "cpsp" 0, "c2sc" 0, "salt" 0, "aalt" 0, "calt", "ccmp", "locl", "kern";
}
</style>
